export default function About() {
  return (
    <section id="about" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          <div className="order-2 md:order-1">
            <div className="inline-block mb-4">
              <span className="text-[#9bc53d] text-sm font-semibold tracking-wider uppercase">Nossa História</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2d5016] mb-4 sm:mb-6 leading-tight">
              Quem Somos?
            </h2>
            <p className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed">
              Bem-vindo ao Rancho da Verdura! Nosso compromisso é trazer o frescor da horta diretamente para a sua mesa. Oferecemos uma ampla variedade de verduras e legumes colhidos fresquinhos, preservando sabor e nutrientes.
            </p>
            <p className="text-gray-600 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed">
              Você encontra diversidade e qualidade em cada prateleira. Além das verduras, temos frutas, legumes, temperos frescos e muito mais, tudo cuidadosamente selecionado para garantir o melhor para você e sua família.
            </p>
            <p className="text-gray-600 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
              Venha nos visitar e sinta a diferença. Rancho da Verdura – Da horta para a sua mesa, com amor e frescor!
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-[#9bc53d]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-leaf-line text-2xl text-[#9bc53d]"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#2d5016] mb-1 text-sm sm:text-base">Produtos Frescos</h3>
                  <p className="text-xs sm:text-sm text-gray-600">Qualidade garantida</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-[#9bc53d]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-smile-line text-2xl text-[#9bc53d]"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#2d5016] mb-1 text-sm sm:text-base">Atendimento</h3>
                  <p className="text-xs sm:text-sm text-gray-600">Equipe dedicada</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-[#9bc53d]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-price-tag-3-line text-2xl text-[#9bc53d]"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#2d5016] mb-1 text-sm sm:text-base">Preço Justo</h3>
                  <p className="text-xs sm:text-sm text-gray-600">Melhor custo-benefício</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-[#9bc53d]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-store-2-line text-2xl text-[#9bc53d]"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#2d5016] mb-1 text-sm sm:text-base">Ambiente</h3>
                  <p className="text-xs sm:text-sm text-gray-600">Limpo e organizado</p>
                </div>
              </div>
            </div>

            <a
              href="https://pedido.anota.ai/loja/rancho-das-verduras-2"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#2d5016] text-white px-6 sm:px-8 py-3 sm:py-3.5 rounded-full text-sm sm:text-base font-semibold hover:bg-[#9bc53d] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Fazer Pedido
            </a>
          </div>

          <div className="order-1 md:order-2">
            <div className="relative">
              <div className="absolute -top-4 -left-4 sm:-top-6 sm:-left-6 w-full h-full bg-[#9bc53d]/10 rounded-3xl"></div>
              <img
                src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/08bc8218e93868ce70c46d09878a45bd.png"
                alt="Rancho da Verdura"
                className="relative rounded-3xl shadow-2xl w-full h-[350px] sm:h-[450px] md:h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
